module.exports = __webpack_public_path__ + "static/bg-01532d5f87b2d6220f4e8b4ddb6bb6f4.jpg";